import Image from "next/image";
import { FlexBox } from "../../salify-next-layout/default/components/flex-box";
import { toAssetImages } from "src/lib/utils";
import { H5, Paragraph } from "../../salify-next-layout/default/components/Typography";
import Card from "@mui/material/Card";

const ResultNotFound = () => (
  <Card sx={{ height: "40vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
    <FlexBox flexDirection="column" alignItems="center" just px={2}>
      <Image
        src={toAssetImages("misc/not-found.png")}
        alt="Result not found"
        width={120}
        height={120}
        sizes="120px"
        style={{ objectFit: "contain" }}
      />
      <H5 mt="20px">Rất tiếc, không tìm thấy kết quả</H5>
      <Paragraph mt="20px" textAlign="center">
        Vui lòng thử lại với từ khóa khác hoặc tìm kiếm sản phẩm theo danh mục
      </Paragraph>
    </FlexBox>
  </Card>
);

export default ResultNotFound;
